<template src="./MapControlButton.html"> </template>
<script>

import { mapActions, mapState } from 'vuex';
// import BottomPanel from '@/modules/BottomPanel/BottomPanel.vue';

export default {
    name: 'MapControlButton',
    props: {
        text: {
            required: true,
            type: String
        },
        icon: {
            required: true,
            type: String
        }
    },
    computed: {
        ...mapState({
            dropPinStatus: state => state.dropPinStatus,
            mapSettings: state => state.mapMode,

            mapConfigOne: state => state.mapConfigOne,
            mapConfigTwo: state => state.mapConfigTwo,

            variable: state => state.menuSettings.variable,

            viewWsLayer: state => state.ws.viewWsLayer,

            ws: state => state.ws.ws,
            layers: state => state.map.mapLayers,
            viewWeatherStationManager: state => state.ws.viewWeatherStationManager,
            viewNotificationsManager: state => state.notifications.viewNotificationsManager,
        }),

        getDropPinStatus: function() {
            return this.dropPinStatus;
        }
    },
    
    components: { },

    data: () => ({
        switch1: true,
        switch2: false,
        wsStatus: false,
        fab: false,
        
        mapItems: [{id: '', description: 'Current'}, {id: 'His', description: 'Historical'}, {id: 'Dev', description: 'Deviation'}],
        map1Option: null,
        map2Option: null,

        wsViewManagerStatus: false,
    }),
    methods: {
        ...mapActions({
            setAlert: 'setAlert',

            setMapConfigOne: 'setMapConfigOne',
            setMapConfigTwo: 'setMapConfigTwo',
            
            setDropPinStatus: 'setDropPinStatus',
            setDataAnalysisStatus: 'setDataAnalysisStatus',

            setWsLayerStatus: 'setWsLayerStatus',
            addMapLayer: 'addMapLayer',

            getStations: 'getStations',

            setViewWeatherStationManager: 'setViewWeatherStationManager',
            setViewNotificationsManager: 'setViewNotificationsManager',
        }),

        onClickSetViewWeatherStationManager() {
            console.log('onClickSetViewWeatherStationManager: ')
            this.wsViewManagerStatus = !this.viewWeatherStationManager
            this.setViewWeatherStationManager(!this.viewWeatherStationManager);

            if (!this.wsViewManagerStatus)
                this.setWsLayerStatus(false);
        },

        setStationLayer() {
            
            if (!sessionStorage.getItem('user-jwt')) {
                this.setAlert({message: 'You must be logged in to load Weather Stations', type: 'error'});
                this.wsStatus = false;
            } else {
                
                if (this.wsStatus) {
                    this.getStations();
                    this.setWsLayerStatus(true);
                } else
                    this.setWsLayerStatus(false);
            }
                // if (this.wsStatus) {
                //     if (this.ws.length > 0) {
                //         if (this.layers.length == 0) {
                //             let layers = [];
                //             this.ws.forEach(ws => {
                //                 layers.push({
                //                     type: 'marker',
                //                     id: ws._id,
                //                     data: ws,
                //                 });
                //             });
                //             this.addMapLayer(layers);
                //         }
                //     } else {
                //         this.getStations();
                //     }
                // } else {
                //     this.addMapLayer([]);
                // }
        },

        setDropPin: function() {
            if (this.dropPinStatus)
                this.setDataAnalysisStatus(false);
            this.setDropPinStatus(!this.dropPinStatus);
        },

        setNotificationsStatus() {
            //this.setWsLayerStatus(!this.viewWsLayer);
            this.setViewNotificationsManager(!this.viewNotificationsManager);
        },

        onSelectStop: function() {

        },

        onSelectMapOne: function() {
            this.setWsLayerStatus(false);
            this.setMapConfigOne({
                url: this.map1Option == null ? '' : this.mapConfigOne.url,
                layer: this.map1Option == null ? '' : (this.variable.id + this.map1Option),
                visibility: this.switch1
            });
        },


        onSelectMapTwo() {            
            this.setMapConfigTwo({
                url: this.map2Option == null ? '' : this.mapConfigOne.url,
                layer:  this.map2Option == null ? '' : (this.variable.id + this.map2Option),
                visibility: this.switch2
            });
        }

    },
}
</script>

<style lang="scss" src="./MapControlButton.scss"> </style>